var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
if (!customElements.get("ona-slider")) {
  customElements.define(
    "ona-slider",
    class Slider extends HTMLElement {
      constructor() {
        super();
        this.prev = this.prev.bind(this);
        this.next = this.next.bind(this);
        this._updateDots = this._updateDots.bind(this);
        this._updateArrows = this._updateArrows.bind(this);
        this._update = this._update.bind(this);
      }
      connectedCallback() {
        this.elements = {
          viewport: this.querySelector(".slider__viewport"),
          items: this.querySelector(".slider__items"),
          prevButton: this.querySelector(".slider__button--prev"),
          nextButton: this.querySelector(".slider__button--next"),
          dots: this.querySelector(".slider__dots")
        };
        if (!this.elements.viewport || !this.elements.items) {
          console.error("Slider: Required elements not found.");
          return;
        }
        this.elements.viewport.classList.add("flicking-viewport");
        this.elements.items.classList.add("flicking-camera");
        if (this.elements.prevButton) {
          this.elements.prevButton.addEventListener("click", this.prev);
        }
        if (this.elements.nextButton) {
          this.elements.nextButton.addEventListener("click", this.next);
        }
        this.manualInit = this.getAttribute("manual") !== null;
        if (!this.manualInit) {
          this.init();
        }
      }
      init() {
        this.align = this.getAttribute("align") || "center";
        this.isVertical = this.getAttribute("vertical") !== null;
        this.isBound = this.getAttribute("bound") !== null;
        if (this.isVertical) {
          this.elements.viewport.classList.add("vertical");
        }
        if (this.align[0] === "{") {
          this.align = JSON.parse(this.align);
        }
        const extra = JSON.parse(this.getAttribute("extra") || null);
        this.flicking = new Flicking(this.elements.viewport, __spreadValues({
          align: this.align,
          horizontal: !this.isVertical,
          bound: this.isBound
        }, extra));
        this._listenFlickingEvents();
      }
      _listenFlickingEvents() {
        if (this.elements.dots) {
          this.flicking.on("willChange", this._updateDots);
          this.flicking.on("changed", this._updateDots);
        }
        this.flicking.on("ready", this._updateArrows);
        this.flicking.on("ready", this._update);
        this.flicking.on("move", this._update);
        this.flicking.on("moveEnd", this._updateArrows);
        this.flicking.on("changed", () => {
          this.dispatchEvent(
            new CustomEvent("slideChanged", {
              detail: { index: this.flicking.index, currentSlide: this.flicking.currentPanel }
            })
          );
        });
      }
      _updatePanels(panels) {
        let activePanel, activeProgress;
        panels.forEach((panel) => {
          const absProgress = Math.abs(panel.progress);
          const isInActiveZone = absProgress < 1;
          panel.element.style.setProperty(
            "--flicking-direction",
            Math.min(Math.max(-1, panel.progress), 1) * (panel.toggled ? -1 : 1)
          );
          panel.element.style.setProperty("--flicking-active-progress", isInActiveZone ? activeProgress : 0);
          if (isInActiveZone && panel.element.ariaHidden === "true") {
            panel.element.setAttribute("aria-hidden", "false");
          } else if (!isInActiveZone && (panel.element.ariaHidden === "false" || !panel.element.ariaHidden)) {
            panel.element.setAttribute("aria-hidden", "true");
          }
          if (isInActiveZone) {
            activePanel = panel;
            activeProgress = 1 - absProgress;
          }
        });
        return { activePanel, activeProgress };
      }
      _update() {
        const status = this._updatePanels(this.flicking.panels);
        this.dispatchEvent(
          new CustomEvent("update", {
            detail: status
          })
        );
      }
      prev() {
        if (this.flicking.index > 0) this.flicking.prev();
      }
      next() {
        if (this.flicking.index < this.flicking.panelCount - 1) this.flicking.next();
      }
      moveTo(index) {
        if (this.flicking.animating) {
          this.flicking.updateAnimation(index, this.flicking.duration);
        } else {
          this.flicking.moveTo(index);
        }
      }
      _updateDots(event) {
        this.elements.dots.querySelectorAll(".slider__dot").forEach((dot) => {
          dot.ariaSelected = false;
        });
        this.elements.dots.querySelector(`.slider__dot:nth-child(${event.index + 1})`).ariaSelected = true;
      }
      _updateArrows() {
        var _a;
        if (!((_a = this.flicking.visiblePanels) == null ? void 0 : _a.length)) return;
        const cam = this.flicking.camera;
        const isAtStart = cam.position === cam.range.min;
        const isAtEnd = cam.position === cam.range.max;
        if (this.elements.prevButton) this.elements.prevButton.disabled = isAtStart;
        if (this.elements.nextButton) this.elements.nextButton.disabled = isAtEnd;
        if (this.elements.prevButton && this.elements.nextButton) {
          if (isAtStart && isAtEnd) {
            this.elements.prevButton.style.display = "none";
            this.elements.nextButton.style.display = "none";
          } else {
            this.elements.prevButton.style.display = "";
            this.elements.nextButton.style.display = "";
          }
        }
      }
    }
  );
}
